import * as api from '@apis/admin-credit-points';
import { SelectUser } from '@components/product/SelectUser';
import { AdminUser } from '@models/auth';
import { AdminCreditPointTemplate } from '@models/credit-points';
import { useOkCancelDialog } from '@stores/okCancelDialogStore';
import { useMutation } from '@tanstack/react-query';
import { Button, Modal } from 'antd';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { useState } from 'react';

export interface BulkPointAddModalProps {
  template?: AdminCreditPointTemplate;
  open?: boolean;
  onClose?: () => void;
  needRefetch?: () => void;
}

export const BulkPointAddModal: React.FC<BulkPointAddModalProps> = (props) => {
  const [selectedUsers, setSelectedUsers] = useState<AdminUser[]>([]);
  const template = props.template;
  const templateId = template?._id;
  const dialog = useOkCancelDialog();

  const bulkPointAddMutation = useMutation({
    mutationFn: api.addCreditPointToUsersByTemplate,
    onSuccess: async () => {
      dialog.open({
        content: '적립되었습니다.',
        type: 'ok',
        onConfirm: () => {
          props.onClose && props.onClose();
        },
      });
      props.needRefetch && props.needRefetch();
    },
    onError: async (e: any) => {
      dialog.open({
        title: '오류',
        content: e?.response?.data?.message,
        type: 'ok',
      });
    },
  });

  return (
    <Modal
      styles={{ footer: { height: '44px' } }}
      open={props.open}
      footer={
        <div style={{ width: '100%' }}>
          <Button
            style={{
              width: 120,
            }}
            onClick={props.onClose}>
            취소
          </Button>
          <Button
            style={{
              width: 120,
              marginLeft: '8px',
            }}
            onClick={() => {
              dialog.open({
                title: '확인',
                content: `${
                  selectedUsers.length
                }명의 사용자에게 ${template?.creditPointName} 포인트(${template?.creditPoint?.toLocaleString()})를 지급합니다.`,
                type: 'ok_cancel',
                onConfirm: () => {
                  if (templateId) {
                    bulkPointAddMutation.mutate({ templateId, userIds: selectedUsers.map((user) => user._id) });
                  }
                },
              });
            }}>
            실행하기
          </Button>
        </div>
      }
      onCancel={props.onClose}>
      <OverlayScrollbarsComponent
        defer
        options={{ scrollbars: { autoHide: 'scroll' } }}
        style={{
          backgroundColor: '#ffffff',
          marginTop: 0,
          position: 'relative',
          height: 'calc(100dvh - 240px)',
          overflow: 'auto',
        }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <div
            style={{
              fontSize: 20,
              fontWeight: 'bold',
              textAlign: 'center',
              marginBottom: 10,
            }}>
            {`${template?.creditPointName}(${template?.creditPoint.toLocaleString()}P) 일괄 적립`}
          </div>
          <div style={{ padding: '8px 0', width: '100%' }}>
            <SelectUser
              placeholder={'대상자를 선택해주세요'}
              onSelect={(user) => {
                setSelectedUsers((users) => {
                  const newValues = [...users];
                  const found = newValues.find((exists) => exists._id === user._id);
                  if (!found) {
                    newValues.push(user);
                  }
                  return newValues;
                });
              }}></SelectUser>
          </div>
          <div style={{ padding: '4px 0', fontWeight: 'bold' }}>{`총 ${selectedUsers.length} 명 선택`}</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
            {selectedUsers.map((user, index) => {
              return (
                <div
                  key={`users-${index}`}
                  style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>{`${user.profile?.name}(${user.profile?.phone?.substring(
                    user.profile?.phone?.length - 4,
                  )})`}</div>
                  <Button
                    style={{ color: 'red' }}
                    onClick={() => {
                      setSelectedUsers((users) => {
                        const newValues = [...users];
                        newValues.splice(index, 1);
                        return newValues;
                      });
                    }}>
                    삭제
                  </Button>
                </div>
              );
            })}
          </div>
        </div>
      </OverlayScrollbarsComponent>
    </Modal>
  );
};
